<template>
    <div class="wrapper">
        <div class="intro">
          <p class="intro">
            {{messages["qsim.thankyou.title"]}}
          </p>
        </div>
        <div class="formBlock">
          <div class="blockTitle noMargin">
              {{messages["qsim.thankyou.table.title"]}}
          </div>
          <p>
            {{messages["qsim.thankyou.table.subtitle"]}}
          </p>
          <div class="space space35"></div>
          <table class="total">
            <tbody>
              <tr>
                <th></th>
                <th class="left">{{messages["qsim.cart.product"]}}</th>
                <th></th>
                <th>{{messages["qsim.cart.cost"]}}</th>
              </tr>
              <tr>
                <td class="card"><img :src="getProduct.imageUrl" style="padding-left:16px"></td>
                <td class="left">{{getProduct.title}}</td>
                <td></td>
                <td>
                  {{getProduct.price}},00€
                </td>
              </tr>
              <tr>
                <td></td>
                <td class="bold left">
                  {{messages["qsim.thankyou.table.total"]}}
                </td>
                <td></td>
                <td class="bold">{{getProduct.price}},00€</td>
              </tr>
            </tbody>
          </table>
          <div class="space space20"></div>
        </div>
        <div class="blockTitle">
          {{messages["qsim.thankyou.steps.title"]}}
        </div>
        <div class="cols3 steps eqBlock colsWrap">
          <div class="eqItem" style="">
            <div class="seperator"></div>
            <div class="img" style="width:40%">
              <img src="/ext_files/prepaid/q/media/thankyou_step1.png">
            </div>
            <div class="cnt">
              <p class="title eqElement" style="">
                {{messages["qsim.thankyou.step1.title"]}}
              </p>
              <p>
                {{messages["qsim.thankyou.step1.description"]}} {{getEmail}}
              </p>
            </div>
          </div>
          <div class="eqItem" style="">
            <div class="seperator"></div>
            <div class="img" style="width:40%">
              <img src="/ext_files/prepaid/q/media/thankyou_step2.png">
            </div>
            <div class="cnt">
              <p class="title eqElement" style="">
                {{messages["qsim.thankyou.step2.title"]}}
              </p>
              <p>
                {{messages["qsim.thankyou.step2.description"]}}
              </p>
            </div>
          </div>
          <div class="eqItem last" style="">
            <div class="seperator"></div>
            <div class="img" style="width:40%">
              <img src="/ext_files/prepaid/q/media/thankyou_step3.png">
            </div>
            <div class="cnt">
              <p class="title eqElement" style="">
                {{messages["qsim.thankyou.step3.title"]}}
              </p>
              <p>
                {{messages["qsim.thankyou.step3.description"]}}
              </p>
            </div>
          </div>
        </div>
        <div class="notification yellow">
          <div class="wrap">
            <span class="icon notYellow"></span><span class="text">
              {{messages["qsim.thankyou.note"]}}
            </span>
          </div>
        </div>
      </div>
</template>

<script>
export default {
  name: 'ThankYou',
  props: {
    messages: Object,
  },
  data: function () {
    return {
    }
  },
  computed: {
    getEmail(){
      return this.$store.state.email;
    },
    getProduct(){
      return this.$store.state.product;
    }
  },
  methods: {

  }
}
</script>

<style>

</style>